import { ColorEnum } from '@/constants/color'
import { Layout } from '@/features/layout/types'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface SummaryItemProps {
    color: ColorEnum
    emphasized?: boolean
    label: string
    layout: Layout
    testID: string
    value: string
}

const SummaryItem: FC<SummaryItemProps> = ({
    color,
    emphasized = false,
    label,
    layout,
    testID,
    value,
}) => {
    const { styles } = useStyles(stylesheet, { layout })

    return (
        <View style={styles.container} testID={testID}>
            <Typography.Menu numberOfLines={1} size="small" style={styles.label}>
                {label.toUpperCase()}
            </Typography.Menu>
            <Typography.Description
                font="medium"
                numberOfLines={1}
                size="large"
                style={[
                    styles.value,
                    layout === 'compact' && emphasized && styles.compactTotalValue,
                    { color },
                ]}
            >
                {value}
            </Typography.Description>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        variants: {
            layout: {
                compact: {
                    width: '100%',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 16,
                },
                extended: {
                    width: 135,
                    gap: 4,
                },
            },
        },
    },
    label: {
        flexShrink: 1,
        lineHeight: 16,
        color: ColorEnum.GRAY_900,
    },
    value: {
        flexShrink: 0,
        lineHeight: 21,
        variants: {
            layout: {
                compact: {
                    textAlign: 'right',
                },
                extended: {
                    textAlign: 'left',
                },
            },
        },
    },
    compactTotalValue: {
        fontSize: 20,
        lineHeight: 24,
    },
})

export default SummaryItem
